import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import { helpers } from "../utils";

export default function OrderSummaryGrid(props) {
  const [summaryData, setSummaryData] = useState();

  useEffect(() => {
    if (summaryData !== props.summaryData) {
      setSummaryData(props.summaryData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.summaryData])

  return (
    <>
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr>
            <th>
              Summary Type
            </th>
            <th style={{textAlign:"center"}}>
              Ext Cost
            </th>
            <th style={{textAlign:"center"}}>
              Ext Price
            </th>
            <th style={{textAlign:"center"}}>
              Margin
            </th>
          </tr>
        </thead>
        <tbody>
          {_.map(summaryData, (datum, index) => {
            return (
              <tr
                key={index}
                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
              >
                <td className="data-cell" children={datum.infoType} />
                <td style={{textAlign:"center"}} className="data-cell" children={helpers.formatCurrency(datum.totalCost)} />
                <td style={{textAlign:"center"}} className="data-cell" children={helpers.formatCurrency(datum.totalPrice)} />
                <td style={{textAlign:"center"}} className="data-cell" children={datum.marginDisplay} />
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
